import {
  useCreate,
  useDelete,
  useDetail,
  useList,
  useUpdate,
  useListAction,
  usePartialUpdate,
} from '@inmagik/react-crud'
import { User } from '../types'
import { API_URL } from '../constants'

export function useUtentiList(params: Record<string, string> = {}) {
  return useList<User>(`${API_URL}/utenti/users`, params)
}

export function useUtente(id: string) {
  return useDetail<User>(`${API_URL}/utenti/users`, id)
}

export function useCreateUtente() {
  return useCreate<User>(`${API_URL}/utenti/users`)
}

export function useUpdateUtente() {
  return useUpdate<User>(`${API_URL}/utenti/users`)
}

export function useDeleteUtente() {
  return useDelete(`${API_URL}/utenti/users`)
}

export function useDeleteMultipleUtenti() {
  return useListAction(`${API_URL}/utenti/users`, 'delete_multiple')
}

export function useChangeExpirationMultipleUtenti() {
  return useListAction(`${API_URL}/utenti/users`, 'change_expiration_date_multiple')
}

export function usePartialUpdateUtente() {
  return usePartialUpdate<User>(`${API_URL}/utenti/users`)
}
